import { InjectedConnector } from '@web3-react/injected-connector';

const SUPPORTED_CHAIN_IDS = [1, 3, 4, 5, 10, 42, 77, 99, 100, 56, 97, 11155111, 42161, 8453, 59144];

export const injected = new InjectedConnector({
  supportedChainIds: SUPPORTED_CHAIN_IDS,
});
